// 在http.js中引入axios
import axios from 'axios'; // 引入axios
import QS from 'qs'; // 引入qs模块，用来序列化post类型的数据，后面会提到
// vant的toast提示框组件，大家可根据自己的ui组件更改。
import { MessageBox, Message } from 'element-ui'
import {
	Toast
} from 'vant';
import 'vant/lib/index.css';
// 环境的切换
axios.defaults.baseURL = 'https://apiv2.zyxkkid.com/api';
// axios.defaults.baseURL = 'http://canyin.huijik.com/api';

// axios.defaults.baseURL = 'http://192.168.124.59:7529'; // 本地

// axios.defaults.baseURL = 'http://zyxkweb.huijik.com'; // web端
// axios.defaults.baseURL = 'http://zyxkjm.huijik.com'; // 加盟端

// axios.defaults.baseURL = 'http://canyin.huijik.com/api';

// axios.defaults.baseURL = 'http://jmv2.zyxkkid.com/api';
// axios.defaults.baseURL = 'http://adminv2.zyxkkid.com/api';



//设置请求超时
axios.defaults.timeout = 10000000;

//设置请求头  
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
//请求拦截
// 先导入vuex,因为我们要使用到里面的状态对象
// vuex的路径根据自己的路径去写
// import store from '@/store/index';


// 请求拦截器
axios.interceptors.request.use(
	config => {
		// 每次发送请求之前判断vuex中是否存在token        
		// 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
		// 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断 
		// const token = "Bearer "+localStorage.getItem("token");
		if (config.url == '/send/msg') {
			return config;
		}
		const token = localStorage.getItem("token");
		if(localStorage.getItem("token")){
			token && (config.headers.Authorization = token); 
		}
		
		return config;
	},
	error => {
		
		return Promise.error(error);
	})

// 响应拦截器
var that = this
axios.interceptors.response.use(
	response => {
		if (response.data.code === 200) {
			return Promise.resolve(response);
		} else if(response.data.code === 401){
			if (localStorage.getItem("userInfo")) {
				var whoLogin = JSON.parse(localStorage.getItem("userInfo")).roles[0].roleId //登录的身份1超管，2子管理员,3加盟校区，4教师，5加盟校区子管理员
			}
			Toast.fail('登录过期，请重新登录');
			window.location.href = '/'
			if(whoLogin==1||whoLogin==2||whoLogin==6){
				window.location.href = '/'
			}else{
				window.location.href = '/'
			}
			
		}else {
			console.log('错误信息_+',response.data.msg)
			// Toast.fail(response.data.msg);
			Message({
				message:response.data.msg || 'Error',
				type: 'error',
				duration: 5 * 1000
			  })
			return Promise.reject(response);
		}
	},
	error => {
		return Promise.reject(error.response);
	});

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
			params: params
		}).then(res => {
			resolve(res.data);
		}).catch(err => {
			reject(err.data)
		})
	});
}

/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 * QS.stringify(params)
 */
export function post(url, params) {
	return new Promise((resolve, reject) => {
		axios.post(url, params)
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err.data)
			})
	});
}
export function put(url, params) {
	return new Promise((resolve, reject) => {
		axios.put(url, params)
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err.data)
			})
	});
}
export function Delete(url, params) {
	return new Promise((resolve, reject) => {
		axios.delete(url, params)
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err.data)
			})
	});
}



// WEBPACK FOOTER //
// ./src/request/http.js